// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__19xQH","footer":"ModalCreateQualiphyProcedure_footer__1jQuv","additionData":"ModalCreateQualiphyProcedure_additionData__1eSFi"};